import { useNavigate } from 'react-router-dom';
import { PATHS } from 'config/paths';
import { getTrans } from 'modules/i18n';
import { ErrorScreen } from '../parts/ErrorScreen';

export const AuthenticationErrorScreen = () => {
  const navigate = useNavigate();

  return (
    <ErrorScreen
      title={getTrans('crashScreen.authenticationError.errorTitle')}
      description1={getTrans(
        'crashScreen.authenticationError.actionText.part1'
      )}
      description2={getTrans(
        'crashScreen.authenticationError.actionText.part2'
      )}
      buttonText={getTrans('crashScreen.authenticationError.buttonTitle')}
      onButtonClick={() => navigate(PATHS.login, { replace: true })}
    />
  );
};
